var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "events" },
    [
      _c("div", { staticClass: "count-events" }, [
        _c(
          "div",
          { staticClass: "choice all" },
          [
            _c("Checkbox", {
              attrs: {
                id: "selectEventInbox",
                isChecked: _vm.multiTask.length >= 1,
                isLine: _vm.multiTask.length > 0 && !_vm.multiTaskAll,
                isDisable: !_vm.list || _vm.list.length == 0,
                add: _vm.selectAllEvents,
                remove: _vm.deselectAllEvents,
              },
            }),
            _vm.isLoading
              ? _c("div", { staticClass: "field" }, [
                  _vm._v("Recherche de contenu"),
                ])
              : _c("div", { staticClass: "field" }, [
                  _vm._v(
                    _vm._s(_vm.totalEvents) +
                      " " +
                      _vm._s(
                        _vm.$t(
                          `dash.inbox.event.total${
                            _vm.totalEvents > 1 ? "s" : ""
                          }`
                        )
                      ) +
                      " " +
                      _vm._s(
                        _vm.multiTask.length
                          ? `(${
                              _vm.multiTaskAll
                                ? _vm.totalEvents
                                : _vm.multiTask.length
                            })`
                          : ""
                      )
                  ),
                ]),
          ],
          1
        ),
        _vm.multiTask.length
          ? _c("div", { staticClass: "cta" }, [
              _c(
                "div",
                { staticClass: "affected_to" },
                [
                  _c(
                    "Tooltip",
                    {
                      attrs: {
                        text: _vm.$t("dash.inbox.tooltip.person_add"),
                        position: "top",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.openPopupSelectUsersMultiTask()
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "fa-solid fa-user-plus" }),
                          _vm._v("\n            Assigner\n          "),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "state" },
                [
                  _c(
                    "Tooltip",
                    {
                      attrs: {
                        text: _vm.$t("dash.inbox.tooltip.playlist_add_check"),
                        position: "top",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.changeMultiTask({ status: "1" })
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fa-regular fa-clipboard-check",
                          }),
                          _vm._v("\n            Traité\n          "),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
      _c(
        "ul",
        { ref: "listEventScrool" },
        [
          _vm.list && _vm.list.length
            ? _vm._l(_vm.getFilterList, function (event, key) {
                return _c(
                  "li",
                  {
                    key: "event-" + key,
                    staticClass: "event card",
                    class: `event-${key} ${
                      _vm.selected && _vm.selected._id == event._id
                        ? "selected"
                        : ""
                    } ${
                      _vm.multiTask && _vm.multiTask.length
                        ? "active-multi-choices"
                        : ""
                    }`,
                    on: {
                      click: function ($event) {
                        return _vm.selectEvent(event)
                      },
                    },
                  },
                  [
                    _c("header", [
                      _c(
                        "div",
                        { staticClass: "context" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "choice",
                              class: {
                                selected: _vm.multiTask.includes(event._id),
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                },
                              },
                            },
                            [
                              _c("Checkbox", {
                                attrs: {
                                  id: event._id,
                                  isChecked: _vm.multiTask.includes(event._id),
                                  add: _vm.addSelectEvent,
                                  remove: _vm.removeSelectEvent,
                                },
                              }),
                            ],
                            1
                          ),
                          _c("Avatar", {
                            attrs: {
                              typeNetwork: _vm.pages.find(
                                (p) =>
                                  p.network_id == event.page &&
                                  p.network == event.network
                              ).network,
                              urlPicture: _vm.pages.find(
                                (p) =>
                                  p.network_id == event.page &&
                                  p.network == event.network
                              ).avatar,
                            },
                          }),
                          _c("p", [
                            _c("span", { staticClass: "page-name" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.pages.find(
                                    (p) =>
                                      p.network_id == event.page &&
                                      p.network == event.network
                                  ).name
                                )
                              ),
                            ]),
                            _vm._v("\n              -\n              "),
                            _c("span", { staticClass: "bold" }, [
                              _vm._v(
                                _vm._s(
                                  _vm
                                    .$t(`dash.inbox.type.${event.type}`)
                                    .split(" ")[0]
                                )
                              ),
                            ]),
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm
                                    .$t(`dash.inbox.type.${event.type}`)
                                    .split(" ")
                                    .slice(
                                      1,
                                      _vm
                                        .$t(`dash.inbox.type.${event.type}`)
                                        .split(" ").length
                                    )
                                    .join(" ")
                                ) +
                                "\n            "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "actions" }, [
                        parseInt(event.status) == 4
                          ? _c("div", { staticClass: "state" }, [
                              _vm._v(
                                _vm._s(_vm.$t("dash.inbox.state.removed"))
                              ),
                            ])
                          : parseInt(event.status) == 5
                          ? _c("div", { staticClass: "state" }, [
                              _vm._v(_vm._s(_vm.$t("dash.inbox.state.hided"))),
                            ])
                          : _c(
                              "div",
                              {
                                staticClass: "state",
                                on: {
                                  click: function ($event) {
                                    _vm.changeEvent(event._id, {
                                      status: _vm.getChangeStatus(event.status),
                                    })
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      [1, 3].includes(parseInt(event.status))
                                        ? _vm.$t("dash.inbox.state.treated")
                                        : _vm.$t("dash.inbox.state.waiting")
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                        _c(
                          "div",
                          {
                            staticClass: "flag",
                            class: [{ active: event.flag }],
                            on: {
                              click: function ($event) {
                                return _vm.changeEvent(event._id, {
                                  flag: event.flag ? "false" : "true",
                                })
                              },
                            },
                          },
                          [_c("i", { staticClass: "fa-solid fa-flag" })]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "content" }, [
                      _c("div", { staticClass: "image-avatar" }, [
                        _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.getDirectLink(event)
                              },
                            },
                          },
                          [
                            event.network == "linkedin" &&
                            event.user &&
                            event.user.logoV2
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      event.user.logoV2.rootUrl ||
                                      event.user.logoV2,
                                  },
                                })
                              : event.user &&
                                event.user.picture &&
                                event.user.picture.data
                              ? _c("img", {
                                  attrs: { src: event.user.picture.data.url },
                                })
                              : _c("img", { attrs: { src: "img/avatar.jpg" } }),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "container-content-event" }, [
                        _c(
                          "div",
                          { staticClass: "content-event" },
                          [
                            _c("div", { staticClass: "title" }, [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.getDirectLink(event)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " \n                " +
                                      _vm._s(_vm.getUsernameEvent(event)) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(
                                "        \n              " +
                                  _vm._s(
                                    _vm.$t(
                                      `dash.inbox.content.${event.type}.title.${event.network}` +
                                        (event.type == "reaction" &&
                                        event.data.changes &&
                                        event.data.changes.value &&
                                        event.data.changes.value.comment_id
                                          ? ".comment"
                                          : "")
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    event.type == "reaction"
                                      ? event.data.changes.value.reaction_type
                                      : event.type == "message-reaction"
                                      ? event.data.messaging.reaction.emoji
                                      : ""
                                  ) +
                                  "\n            "
                              ),
                            ]),
                            event.type == "rating"
                              ? [
                                  _c("div", { staticClass: "message" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          `${_vm.$t(
                                            `dash.inbox.content.rating.detail.recommendation_type`
                                          )} : ${
                                            event.data.changes.value
                                              .recommendation_type
                                          }`
                                        ) +
                                        " "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          `${_vm.$t(
                                            `dash.inbox.content.rating.detail.review_text`
                                          )} : ${
                                            event.data.changes.value.review_text
                                          }`
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                ]
                              : event.network == "linkedin"
                              ? [
                                  event.type == "comment" &&
                                  event.data.decoratedGeneratedActivity
                                    ? _c("div", {
                                        staticClass: "message",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.messagePostFormatLinkedin(
                                              event.data
                                                .decoratedGeneratedActivity
                                                .comment.text
                                            )
                                          ),
                                        },
                                      })
                                    : event.type == "comment" &&
                                      event.data.detail &&
                                      event.data.detail.comment
                                    ? _c("div", {
                                        staticClass: "message",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.messagePostFormatLinkedin(
                                              event.data.detail.comment.message
                                                .text
                                            )
                                          ),
                                        },
                                      })
                                    : event.type == "mention" &&
                                      event.data.decoratedGeneratedActivity
                                    ? _c("div", {
                                        staticClass: "message",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.messagePostFormatLinkedin(
                                              event.data
                                                .decoratedGeneratedActivity
                                                .share.text
                                            )
                                          ),
                                        },
                                      })
                                    : event.type == "message" &&
                                      event.data.messages &&
                                      event.data.messages.elements &&
                                      event.data.messages.elements.length &&
                                      event.data.messages.elements[0].body &&
                                      event.data.messages.elements[0].body.text
                                    ? _c("div", {
                                        staticClass: "message",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.messagePostFormatLinkedin(
                                              event.data.messages.elements[0]
                                                .body.text
                                            )
                                          ),
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              : [
                                  "mention",
                                  "post",
                                  "status",
                                  "photo",
                                  "video",
                                  "share",
                                  "comment",
                                ].includes(event.type)
                              ? [
                                  _c("div", { staticClass: "message" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          event.data.changes.value.message ||
                                            event.data.changes.value.text
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                ]
                              : event.type == "message"
                              ? [
                                  _c("div", { staticClass: "message" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          event.data.messaging.message.text
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                        _c("div", { staticClass: "footer" }, [
                          _c("div", { staticClass: "left" }, [
                            _c("div", { staticClass: "affected_to" }, [
                              _c(
                                "div",
                                { staticClass: "list" },
                                [
                                  _vm._l(
                                    event.affected_to
                                      ? event.affected_to.slice(0, 10)
                                      : [],
                                    function (user, index) {
                                      return _vm.findUser(user)
                                        ? [
                                            _c(
                                              "Tooltip",
                                              {
                                                key: index,
                                                attrs: {
                                                  text: `${
                                                    _vm.findUser(user).lastname
                                                  } ${
                                                    _vm.findUser(user).firstname
                                                  } (${
                                                    _vm.findUser(user).email
                                                  })`,
                                                },
                                              },
                                              [
                                                !_vm.findUser(user).avatar ||
                                                !_vm.findUser(user).avatar
                                                  .length
                                                  ? _c("img", {
                                                      staticClass: "image-user",
                                                      attrs: {
                                                        src: require("../../../assets/img/ico-man.svg"),
                                                      },
                                                    })
                                                  : _vm.findUser(user).avatar &&
                                                    !!_vm.findUser(user).avatar
                                                      .length
                                                  ? _c("img", {
                                                      staticClass: "image-user",
                                                      attrs: {
                                                        src: _vm.findUser(user)
                                                          .avatar,
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        : _vm._e()
                                    }
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "add-user",
                                      on: {
                                        click: function ($event) {
                                          _vm.popupSelectUsers = true
                                        },
                                      },
                                    },
                                    [
                                      event.affected_to.length < 10
                                        ? _c("i", {
                                            staticClass:
                                              "fa-solid fa-user-plus",
                                          })
                                        : _c("p", [
                                            _vm._v(
                                              "+" +
                                                _vm._s(
                                                  event.affected_to.length - 10
                                                )
                                            ),
                                          ]),
                                    ]
                                  ),
                                ],
                                2
                              ),
                            ]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "right" },
                            [
                              _c(
                                "ContextMenu",
                                {
                                  attrs: {
                                    options: [
                                      {
                                        name: "good",
                                        label: `<div class='badge-evaluation good'>${_vm.$t(
                                          "dash.inbox.filter.evaluation.good"
                                        )}</div>`,
                                      },
                                      {
                                        name: "normal",
                                        label: `<div class='badge-evaluation normal'>${_vm.$t(
                                          "dash.inbox.filter.evaluation.normal"
                                        )}</div>`,
                                      },
                                      {
                                        name: "bad",
                                        label: `<div class='badge-evaluation bad'>${_vm.$t(
                                          "dash.inbox.filter.evaluation.bad"
                                        )}</div>`,
                                      },
                                      {
                                        name: "none",
                                        label: `<div class='badge-evaluation none'>${_vm.$t(
                                          "dash.inbox.filter.evaluation.none"
                                        )}</div>`,
                                      },
                                    ],
                                    addClass: "context-menu-evaluation",
                                    id: event._id,
                                  },
                                  on: { clickOption: _vm.changeEvaluation },
                                },
                                [
                                  _c("div", { staticClass: "notation" }, [
                                    event.evaluation == 1
                                      ? _c("i", {
                                          staticClass: "fa-solid fa-face-frown",
                                          staticStyle: { color: "#FF5C5C" },
                                        })
                                      : event.evaluation == 2
                                      ? _c("i", {
                                          staticClass: "fa-solid fa-face-smile",
                                          staticStyle: { color: "#FFC93D" },
                                        })
                                      : event.evaluation == 3
                                      ? _c("i", {
                                          staticClass: "fa-solid fa-face-laugh",
                                          staticStyle: { color: "#1CD185" },
                                        })
                                      : _c("i", {
                                          staticClass: "fa-solid fa-face-meh",
                                          staticStyle: { color: "#9FA4A8" },
                                        }),
                                  ]),
                                ]
                              ),
                              _c("div", { staticClass: "date" }, [
                                _vm._v(_vm._s(_vm.formatDate(event.date))),
                              ]),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                )
              })
            : !_vm.isLoading || _vm.pages.length == 0
            ? [_vm._m(0)]
            : _vm._e(),
          _vm._l(
            _vm.isLoading
              ? 5
              : _vm.list && _vm.list.length < _vm.totalEvents
              ? 1
              : 0,
            function (index) {
              return _c(
                "li",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isLoading && _vm.pages.length,
                      expression: "isLoading && pages.length",
                    },
                  ],
                  key: "event-loading-" + index,
                  staticClass: "event card loading-content wave-effect",
                },
                [
                  _c("header"),
                  _c("div", { staticClass: "content" }, [
                    _vm._m(1, true),
                    _c("div", { staticClass: "container-content-event" }, [
                      _c("div", { staticClass: "content-event" }, [
                        _vm._m(2, true),
                        _c("div", { staticClass: "message" }, [
                          _c("span", { staticClass: "wave-effect" }, [
                            _vm._v(_vm._s("w".repeat(Math.random() * 50))),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "footer" }, [
                        _c("div", { staticClass: "left" }, [
                          _c("div", { staticClass: "affected_to" }, [
                            _c(
                              "div",
                              { staticClass: "list" },
                              _vm._l(
                                Math.floor(Math.random() * 5) + 1,
                                function (index2) {
                                  return _c("img", {
                                    key:
                                      "event-loading" +
                                      index +
                                      "-image-user" +
                                      index2,
                                    staticClass: "image-user wave-effect",
                                    attrs: {
                                      src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAJElEQVRoge3BAQEAAAjDoPUvfYMItG0BAAAAALwHAAAAwC/VAZFoA/0E7YaAAAAAAElFTkSuQmCC",
                                    },
                                  })
                                }
                              ),
                              0
                            ),
                          ]),
                        ]),
                        _vm._m(3, true),
                      ]),
                    ]),
                  ]),
                ]
              )
            }
          ),
        ],
        2
      ),
      _c(
        "vs-popup",
        {
          staticClass: "overlay groups shared-planner affected_to",
          attrs: {
            title: _vm.$t("dash.inbox.event.affected_to.title"),
            active: _vm.popupSelectUsers,
          },
          on: {
            "update:active": function ($event) {
              _vm.popupSelectUsers = $event
            },
          },
        },
        [
          _vm.popupSelectUsers
            ? _c("component-users-selector", {
                attrs: { usersAdded: _vm.usersAdded },
                on: { submit: _vm.addAffectedToEvent },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "vs-popup",
        {
          staticClass: "overlay groups shared-planner affected_to",
          attrs: {
            title: _vm.$t("dash.inbox.event.affected_to.title"),
            active: _vm.popupSelectUsersMultiTask,
          },
          on: {
            "update:active": function ($event) {
              _vm.popupSelectUsersMultiTask = $event
            },
          },
        },
        [
          _vm.popupSelectUsersMultiTask
            ? _c("component-users-selector", {
                attrs: { usersAdded: [] },
                on: { submit: _vm.addAffectedToMultiTask },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "card-none-event" }, [
      _c("div", { staticClass: "text" }, [
        _c("h4", [
          _vm._v("\n            Aucun resultat\n            "),
          _c("i", { staticClass: "fa-solid fa-magnifying-glass" }),
        ]),
        _c("p", [
          _vm._v(
            "\n            Les paramètres de votre filtre ne correspondent à aucun événement\n          "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "image-avatar" }, [
      _c("a", [
        _c("img", {
          staticClass: "wave-effect",
          attrs: {
            src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAJElEQVRoge3BAQEAAAjDoPUvfYMItG0BAAAAALwHAAAAwC/VAZFoA/0E7YaAAAAAAElFTkSuQmCC",
          },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title" }, [
      _c("a", { staticClass: "wave-effect" }, [_vm._v("wwwwwww")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "right" }, [
      _c("div", { staticClass: "date wave-effect" }, [_vm._v("wwwwwwww")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }